import type { T } from '@common/hooks/useTranslation';

export function termsAndPrivacyConsentRules(t: T, brandNameText: string) {
  return {
    required: t('validations.general.termsAndPrivacy.required', {
      brandNameText
    })
  };
}
